import { Mongo } from "meteor/mongo";
import { Notification } from "lib";

export const Notifications = new Mongo.Collection<Notification>(
  "notifications"
);
